<template>
  <div name="noticeboard" class="extra-curricular pb-10">
    <header class="inner-head border-transparent">
      <div class="flex justify-between">
        <h2 class="inner-head-title">Notices</h2>
      </div>
    </header>

    <div class="header-subnav-holder">
      <button
        v-for="path in tabsList"
        :key="path.id"
        type="button"
        class="header-subnav focus:outline-none"
        @click="showPath(path)"
        v-bind:class="[selectedPath.id === path.id ? 'selected' : '']"
      >
        {{ path.name }}
      </button>
    </div>

    <FilterBar @searchChanged="setSearchValue">
      <template v-slot:filter>
        <div></div>
      </template>

      <template v-slot:actions>
        <div>
          <button
            v-if="selectedPath.id === 1"
            type="button"
            class="action-button hover:opacity-75"
            @click="addNew()"
          >
            <i class="fas fa-plus"></i>
            Add New
          </button>
        </div>
      </template>
    </FilterBar>

    <div class="row bg-white w-95p mx-auto">
      <template v-if="parsedNotices.length > 0">
        <div
          v-for="post in parsedNotices"
          :key="post.id"
          @click="userDidSelectPost(post)"
          class="flex justify-between py-6 px-4 border-b border-gray-300 cursor-pointer border-solid hover:opacity-75"
        >
          <div class="flex items-top space-x-4 w-full">
            <div class="flex flex-col space-y-1 w-11/12 text-left">
              <div class="font-bold text-base">
                {{ post.user.name }}
              </div>

              <div class="flex w-full">
                <div class="w-10/12">
                  <div class="flex-none text-gray-500 text-sm">
                    {{ parsePostedDate(post) }}
                  </div>

                  <div class="text-sm">{{ post.outline }}</div>
                </div>
                <div class="text-sm w-1/12 text-right">
                  <i class="fas fa-chevron-right opacity-50 text-xs"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <p v-else>No notices available</p>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

import { PostService } from "@/services/post.service";
const FilterBar = () => import("@/components/FilterBarNavigation.vue");

export default {
  name: "noticeboard",
  mixins: [],
  props: {},
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    tabsList() {
      return this.tabs;
    },
    parsedNotices() {
      let results = this.notices.filter((item) => {
        return item.outline.toLowerCase().includes(this.search.toLowerCase());
      });

      if (this.selectedPath.id === 1) {
        return results.filter((item) => item.is_active === true);
      } else if (this.selectedPath.id === 2) {
        return results.filter(
          (item) => item.is_active === true && item.posted_date > moment()
        );
      } else {
        return results.filter((item) => item.is_active === false);
      }
    },
  },
  data() {
    return {
      notices: [],
      search: "",
      loading: false,
      errored: false,
      tabs: [],
      selectedPath: {},
    };
  },
  mounted() {
    this.fetchNotices();
    this.tabs = [
      { id: 1, name: "Active", path: "active" },
      { id: 2, name: "Scheduled", path: "scheduled" },
      { id: 3, name: "Paused", path: "paused" },
    ];

    this.selectedPath = this.tabs[0];
  },
  methods: {
    fetchNotices() {
      PostService.getByType("notice", "private")
        .then((response) => {
          this.notices = response.data.data;
        })
        .catch((err) => {
          console.log("notices " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    parsePostedDate(post) {
      let date = moment(post.posted_date, "YYYY-MM-DD HH:mm:ss GMT Z");
      const timestamp = date.diff(Date.now(), "days");

      return timestamp < -7 ? date.format("Do MMMM YYYY") : date.fromNow();
    },
    setSearchValue(value, time = 300) {
      this.search = value;
    },
    addNew() {
      let notice = {};
      this.$router.push({
        name: "NoticeEdit",
        params: {
          noticeObject: notice,
          newAddition: true,
        },
      });
    },
    showPath(object) {
      if (this.selectedPath.id === object.id) {
        return;
      }
      this.selectedPath = object;
    },
    userDidSelectPost(post) {
      this.$router.push({
        name: "NoticeEdit",
        params: {
          noticeObject: post,
          newAddition: false,
        },
      });
    },
  },
  components: {
    FilterBar
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
